import { useGlobalAlert } from "hooks/useAlert";

interface WithActionErrorOptions {
  throwOnUnknownError?: boolean;
  unknownErrorMessage?: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function withActionError(action: () => Promise<any>, options: WithActionErrorOptions = {}) {
  try {
    return await action();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    if (error.response?.data?.errors) {
      return {
        errors: error.response.data.errors,
      };
    } else {
      if (options.throwOnUnknownError) {
        throw error;
      } else {
        return {
          errors: options.unknownErrorMessage || `An unknown error occurred: ${error}`,
        };
      }
    }
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function withActionErrorAlert(action: () => Promise<any>, options: WithActionErrorOptions = {}) {
  const result = await withActionError(action, options);
  if (result.errors) {
    useGlobalAlert.alertError(
      Object.keys(result.errors)
        .map((key: string) => `${key}: ${result.errors[key].join(", ")}`)
        .join("\n"),
    );
  }
  return result;
}
